// extracted by mini-css-extract-plugin
export default {"containerDelete":"botoesAcao_containerDelete__snREK","containerStep":"botoesAcao_containerStep__GLHG8","button":"botoesAcao_button__38U7a"};